'use client';

import { type ComponentProps, useCallback } from 'react';
import { MenuButton } from '@frameio/vapor';
import { usePrefetch } from '../hooks/usePrefetch';

/**
 * Next Link rendered in a MenuButton, prewired up to use our limited list prefetch strategy
 */
export const MenuButtonWithPrefetch = ({
  children,
  href,
  onMouseLeave: onMouseLeaveProp,
  onMouseMove: onMouseMoveProp,
  ...props
}: ComponentProps<typeof MenuButton>) => {
  const {
    onMouseLeave: prefetchOnMouseLeave,
    onMouseMove: prefetchOnMouseMove,
  } = usePrefetch(href, {
    isNextLink: true,
    placement: 'SINGLE',
  });

  const handleOnMouseLeave = useCallback(
    (e) => {
      prefetchOnMouseLeave(e);
      onMouseLeaveProp?.(e);
    },
    [onMouseLeaveProp, prefetchOnMouseLeave]
  );

  const handleOnMouseMove = useCallback(
    (e) => {
      prefetchOnMouseMove(e);
      onMouseMoveProp?.(e);
    },
    [onMouseMoveProp, prefetchOnMouseMove]
  );

  return (
    <MenuButton
      as={'a'}
      isLink={true}
      onMouseLeave={handleOnMouseLeave}
      onMouseMove={handleOnMouseMove}
      {...props}
    >
      {children}
    </MenuButton>
  );
};
